import React from "react";
import {TRADER_NOTIFICATIONS} from "../components/notificationScope";
import {CabinetSettings} from "./CabinetSettings";

/** «Настройки» трейдера: вход в кабинет и уведомления. У мерчанта — MerchantSettingsPage. */
export function SettingsPage(): JSX.Element {
  return <CabinetSettings scope={TRADER_NOTIFICATIONS} className="settings-page"/>;
}
